module.exports = __webpack_public_path__ + "img/download.ae906b96.svg";